import { Injectable } from '@angular/core';
import { HttpClientService } from 'app/shared';
import { environment } from 'environments';

@Injectable()
export class ForumService {

  apiEndpoint = environment.apiEndpoint

  constructor( private httpClientService: HttpClientService ) {



  }



  getConfigurations() {

    return this.httpClientService.get(`${this.apiEndpoint}forum/configurations`)

  }



  updateConfigurations(configurations) {

    return this.httpClientService.put(`${this.apiEndpoint}forum/configurations/${configurations.id}`, configurations)

  }



  saveConfigurations(configurations) {

    return this.httpClientService.post(`${this.apiEndpoint}forum/configurations`, configurations)

  }



  uploadProfilePicture(picture) {

    return this.httpClientService.post(`${this.apiEndpoint}forum/upload/images`, picture)

  }



  getCategories() {

    return this.httpClientService.get(`${this.apiEndpoint}forum/categories/list`)

  }



  saveCategories(category) {

    return this.httpClientService.post(`${this.apiEndpoint}forum/categories/persist`, category)

  }



  deleteCategories(categoryId) {

    return this.httpClientService.delete(`${this.apiEndpoint}forum/categories/delete/${categoryId}`)

  }



  getSubcategories() {

    return this.httpClientService.get(`${this.apiEndpoint}forum/sub_categories/list`)

  }



  saveSubcategories(subcategory) {

    return this.httpClientService.post(`${this.apiEndpoint}forum/sub_categories/persist`, subcategory)

  }



  deleteSubcategories(subcategoryId) {

    return this.httpClientService.delete(`${this.apiEndpoint}forum/sub_categories/delete/${subcategoryId}`)

  }

}



// WEBPACK FOOTER //
// ./src/app/forum/forum.service.ts